

import { baseUrl_SPB } from '../BaseUrl';
async function updateReimbursement(record, token) {
    let tokenv = token.toString();
    let dataToPost = {
        reimbursementId: record.reimbursementId,
        claimantId: record.claimantId,
        claimedAmount: record.claimedAmount,
        reviewAttachmentDataArray: record ? record.reviewAttachmentDataArray : null,
    }

    try {
        const response = await fetch(`${baseUrl_SPB}/api/v1/reimburse/updatereimbursement`, {
            method: 'POST',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenv
            },
            body: JSON.stringify(dataToPost),
        });

    } catch (error) {
        console.error('Error:', error);
    }
}

async function deleteReimbursement(token, reimbursementId) {
    console.log(reimbursementId);
    let tokenv = token;

    try {
        const response = await fetch(`${baseUrl_SPB}/api/v1/reimburse/deletereimbursement?reimbursementId=${reimbursementId}`, {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenv
            },

        });

        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        console.error('Error:', error);
    }
}

async function updateReimbursementAll(record, token,onApprove) {
    let tokenv = token;
    let dataToPost =record; /*{
        reimbursementId: record.reimbursementId,
        claimantId: record.claimantId,
        claimedAmount: record.claimedAmount,
        claimantId: record.claimantId,
        claimantFullName: record.claimantFullName,
        claimedAmount: record.claimedAmount,
        status: record.status,
        amount: record.amount,
        extractedAmount: record.extractedAmount,
        s3ConnectionUrl: record.s3ConnectionUrl,
        invoiceDate: record.invoiceDate,
        fileName: record.fileName,
        createdDate: record.createdDate,
        createdBy: record.createdBy,
        transactionReference: record.transaction_reference,
        additionalInfo: record.additional_info,
        claimantManagerId: record.claimantManagerId,
        
        purchaseOrder: record.purchaseOrder,
        accountPayabaleDate:record.accountPayabaleDate,
        accountPayabaleAmount:record.accountPayabaleAmount,
        
        status:record.status,
        subStatus:record.subStatus,
        nextSubStatus:record.nextSubStatus,


        reviewAttachmentDataArray: record ? record.reviewAttachmentDataArray : null,
    }*/

    try {
        fetch(`${baseUrl_SPB}/api/v1/reimburse/updatereimbursementall`, {
            method: 'POST',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenv
            },
            body: JSON.stringify(dataToPost),
        }).then((res) => {
            console.log(res);
            if(onApprove){
            onApprove(record.reimbursementId,record.subStatus);
            }
        });
    } catch (error) {
        console.error('Error:', error);
    }
}


async function saveReversalService(record, token,onApprove) {
    let tokenv = token;
    let dataToPost =record;
    try {
        fetch(`${baseUrl_SPB}/api/v1/reimburse/reverse`, {
            method: 'POST',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenv
            },
            body: JSON.stringify(dataToPost),
        }).then((res) => {
            console.log(res);
            if(onApprove){
            onApprove(record.reimbursementId,record.subStatus);
            }
        });
    } catch (error) {
        console.error('Error:', error);
    }
}


async function saveCorrectionService(record, token,onApprove) {
    let tokenv = token;
    let dataToPost =record;
    try {
        fetch(`${baseUrl_SPB}/api/v1/reimburse/correctentry`, {
            method: 'POST',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenv
            },
            body: JSON.stringify(dataToPost),
        }).then((res) => {
            console.log(res);
            if(onApprove){
            onApprove(record.reimbursementId,record.subStatus);
            }
        });
    } catch (error) {
        console.error('Error:', error);
    }
}


export { updateReimbursement, deleteReimbursement,updateReimbursementAll,saveReversalService,saveCorrectionService };




